export type ItemGroupEntry = { name: string; count: number };

/**
 * Thứ tự nhóm = vị trí item ĐẦU TIÊN thuộc nhóm đó trong mảng truyền vào.
 * Bỏ item chưa gán nhóm (group_name null / rỗng / chỉ khoảng trắng).
 * Nguồn DUY NHẤT cho thứ tự nhóm — dùng chung hàng tiêu đề nhóm + popover quản lý nhóm.
 */
export function deriveGroupOrder(items: { group_name?: string | null }[]): ItemGroupEntry[] {
  const order: string[] = [];
  const count = new Map<string, number>();
  for (const it of items) {
    const k = ((it as any).group_name as string) || '';
    if (!k) continue;
    if (!count.has(k)) { count.set(k, 0); order.push(k); }
    count.set(k, count.get(k)! + 1);
  }
  return order.map(name => ({ name, count: count.get(name)! }));
}
